module.exports = __webpack_public_path__ + "img/p1.fe797ec3.png";